var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKbvCorner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.932.991l0,.018a.659.659,0,0,0-.5.733l1.279,8.926L.88,15.721H14.323L7.991,10.237l-.327-2.28A5.27,5.27,0,0,1,11.1,6.393q2.359-.158,3.763-3.083L15.207.121a7.344,7.344,0,0,1-3.551,1.555A11.2,11.2,0,0,1,8.34,1.332,15.494,15.494,0,0,0,6.186,1,.664.664,0,0,0,6.047.992Z",
    fill: "#65BE3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbvCorner);
export default __webpack_public_path__ + "static/media/kbv-corner.c1c977176f212f864ce4540bfb597f68.svg";
export { ForwardRef as ReactComponent };